module.exports = __webpack_public_path__ + "static/media/export.b4634bb2.svg";